import * as React from 'react';
import {connect} from 'react-redux';
// @ts-expect-error
import Select, {components} from 'react-select';
// @ts-expect-error
import type {SingleValueProps, OptionProps} from 'react-select';

import {stopSubmit} from 'redux-form';
// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {colors} from 'shells/colors/colors';

import type {GoalType} from 'nutshell-graphql-types';

import {
    getGoalFormTitleForType,
    getGoalFormSubtitleForType,
    getGoalIconForType,
} from '../../constants';

import styles from './goal-type-select.module.css';

const options = [
    {value: 'BASIC_INFO', label: getGoalFormTitleForType('BASIC_INFO')},
    {value: 'LEAD_VALUE', label: getGoalFormTitleForType('LEAD_VALUE')},
    {value: 'ACTIVITY_SCHEDULED', label: getGoalFormTitleForType('ACTIVITY_SCHEDULED')},
    {value: 'ACTIVITY_LOGGED', label: getGoalFormTitleForType('ACTIVITY_LOGGED')},
    {value: 'EMAIL_SENT', label: getGoalFormTitleForType('EMAIL_SENT')},
    {value: 'EMAIL_CLICKED', label: getGoalFormTitleForType('EMAIL_CLICKED')},
    {value: 'EMAIL_RECEIVED', label: getGoalFormTitleForType('EMAIL_RECEIVED')},
    {value: 'LEAD_FIELDS', label: getGoalFormTitleForType('LEAD_FIELDS')},
    {value: 'QUOTE_SENT', label: getGoalFormTitleForType('QUOTE_SENT')},
    {value: 'QUOTE_ACCEPTED', label: getGoalFormTitleForType('QUOTE_ACCEPTED')},
    {value: 'INVOICE_SENT', label: getGoalFormTitleForType('INVOICE_SENT')},
    {value: 'INVOICE_PAID', label: getGoalFormTitleForType('INVOICE_PAID')},
];

type OwnProps = {
    id?: string;
    maxMenuHeight: number;
};

type DispatchProps = {
    onChange: (
        option:
            | {
                  value: string;
              }
            | any[]
            | undefined
            | null
    ) => void;
};

type OwnFieldProps = FieldProps & OwnProps;

type Props = OwnFieldProps & DispatchProps;

// @ts-expect-error
function mapDispatchToProps(dispatch, ownProps: FieldProps): DispatchProps {
    return {
        onChange: (option) => {
            if (!option || Array.isArray(option)) return;
            ownProps.input.onChange(option.value);
            // This resets the "submitFailed" meta key,
            // so we stop showing validation errors
            dispatch(stopSubmit('sa-stage-goal'));
        },
    };
}

export function GoalTypeSelectComponent(props: Props) {
    const displayedOptions = options;

    return (
        <Select
            inputId={props.id}
            value={displayedOptions.find(({value}) => value === props.input.value)}
            options={displayedOptions}
            // @ts-expect-error
            className={styles['react-select']}
            backspaceRemovesValue={false}
            isClearable={false}
            isSearchable={false}
            placeholder='Choose a stage goal…'
            onChange={props.onChange}
            openMenuOnFocus={true}
            maxMenuHeight={props.maxMenuHeight}
            styles={{
                // @ts-expect-error
                control: (base, state) => ({
                    ...base,
                    '&:hover': {
                        borderColor: colors.greyLt,
                    },
                    cursor: state.isDisabled ? 'default' : 'pointer',
                    borderColor: state.isFocused ? colors.greyLt : colors.offWhiteDk,
                    borderRadius: 3,
                    borderWidth: 1,
                    boxShadow: 'none',
                    top: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }),
                // @ts-expect-error
                singleValue: (base) => ({
                    ...base,
                    color: colors.grey,
                }),
                // @ts-expect-error
                option: (base, state) => ({
                    ...base,
                    ':active': {
                        backgroundColor: state.isSelected
                            ? colors.listSelected
                            : colors.listHovered,
                    },

                    backgroundColor: state.isSelected
                        ? colors.listSelected
                        : state.isFocused
                        ? colors.listHovered
                        : base.backgroundColor,
                }),
                // @ts-expect-error
                menu: (base) => ({
                    ...base,
                    zIndex: 2 /* Keep on top of `and` from multiple learn-something-specific items */,
                }),
            }}
            components={{
                Option: OptionComponent,
                SingleValue: SingleValueComponent,
            }}
        />
    );
}

// @ts-expect-error
const connector = connect<Props, OwnFieldProps, _, _, _, _>(null, mapDispatchToProps);
export const GoalTypeSelect = connector(GoalTypeSelectComponent);

const SingleValueComponent = (props: SingleValueProps) => {
    return (
        <components.SingleValue {...props}>
            <GoalTypeValue {...props.data} />
        </components.SingleValue>
    );
};

const OptionComponent = (props: OptionProps) => {
    return (
        <components.Option {...props}>
            <GoalTypeOption value={props.data.value} label={props.data.label} />
        </components.Option>
    );
};

function GoalTypeOption(props: {value: GoalType; label: string}) {
    const GoalIcon = getGoalIconForType(props.value);

    return (
        <div className={styles['goal-type-option']}>
            <div className={styles['goal-type-option-icon']}>
                <GoalIcon wrapWithDiv={false} fill={colors.grey} size={18} />
            </div>
            <div className={styles['goal-type-option-text']}>
                <h3 className={styles['goal-type-option-title']}>{props.label}</h3>
                <span className={styles['goal-type-option-subtitle']}>
                    {getGoalFormSubtitleForType(props.value)}
                </span>
            </div>
        </div>
    );
}

function GoalTypeValue(props: {value: GoalType; label: string}) {
    const GoalIcon = getGoalIconForType(props.value);

    return (
        <div className={styles['goal-type-value']}>
            <div className={styles['goal-type-option-icon']}>
                <GoalIcon size={18} fill={colors.grey} />
            </div>
            <h3 className={styles['goal-type-option-title']}>{props.label}</h3>
        </div>
    );
}
